<template>
  <div
    class="block"
    :class="{ flat }"
  >
    <div class="block__wrapper">
      <p class="typography__headline3">{{ t("entities.knowledgeBaseBlock.title") }}</p>

      <p v-html="t('entities.knowledgeBaseBlock.description')" />
    </div>

    <BaseLink
      class="base-button-big"
      :class="flat ? 'main-base-button-four' : 'main-base-button-third'"
      :href="`/${locale}/faq`"
    >
      {{ t("entities.knowledgeBaseBlock.button") }}
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  flat?: boolean;
}>();

const { t, locale } = useI18n();
</script>

<style scoped>
.block {
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 24px;
  width: 100%;
  padding: 24px 40px;
  border-radius: 32px;
  background-color: var(--grey-7);
}

.block.flat {
  border: 1px solid var(--grey-5);
  background-color: var(--white);
}

.block__wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 12px;
}
</style>
